<app-spinner *ngIf="isLoading"></app-spinner>


<div *ngIf="!isLoading" class="d-flex flex-column" style="height: 100vh;">
  <nav *ngIf="isLoggedIn" class="navbar navbar-expand-lg navbar-light bg-light fixed-top">
    <a class="navbar-brand" href="#" style="padding-left: 30px;">Arihant</a>
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav"
      aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarNav" style="justify-content: flex-end;">
      <ul class="navbar-nav ml-auto">
        <li class="nav-item position-relative">
          <app-notification/>
        </li>
        
        <li class="nav-item">
          <a class="nav-link" href="#" (click)="logout()">Logout</a>
        </li>
      </ul>
    </div>
  </nav>

  <div class="container-fluid" style="margin-top: 56px; overflow: auto; flex: 1;" *ngIf="isLoading == false">
    <div class="row" style="height: 100%;">
      <div [ngClass]="{'col-md-2': isLoggedIn, 'd-none': !isLoggedIn}" class="sidebar-sticky">
        <app-side-bar [itemList]="itemList" (itemSelected)="onItemSelected($event)"></app-side-bar>
      </div>
      <ng-container *ngIf="isLoading == false">
        <main [ngClass]="{'col-md-10': isLoggedIn, 'col-12': !isLoggedIn, 'col-md-0': isLoading}">
          <div class="container-fluid" *ngIf="isLoading == false">
            <div class="row justify-content-center align-items-center vh-95">
              <div class="col-12 text-center">
                <router-outlet></router-outlet>
              </div>
            </div>
          </div>
        </main>
      </ng-container>
    </div>
  </div>
</div>
